import { render, staticRenderFns } from "./FeatureDuration.vue?vue&type=template&id=2de275dd&scoped=true"
import script from "./FeatureDuration.vue?vue&type=script&lang=js"
export * from "./FeatureDuration.vue?vue&type=script&lang=js"
import style0 from "./FeatureDuration.vue?vue&type=style&index=0&id=2de275dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de275dd",
  null
  
)

export default component.exports